<template>
  <v-dialog v-model="showDialog" width="700">
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            :attrs="attrs"
            v-on="{ ...tooltip, ...dialog }"
            class="ma-6"
          >
            <v-avatar size="85" :class="borderClass">
              <PatientPicture :avatar="attendance.patient.avatar" />
            </v-avatar>
          </v-btn>
        </template>
        <span v-if="attendance.fittedSchedule">Encaixe</span>
        <span v-else>Agendado</span>
      </v-tooltip>
    </template>

    <v-tabs v-model="tabs">
      <v-tab v-for="(value, key) in paths" :key="key">
        <v-card-title class="headline grey lighten-2">
          {{ value }}
        </v-card-title>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item v-for="(value, key) in paths" :key="key">
        <v-card v-if="value == paths.documents">
          <v-card-title>Foto do Paciente</v-card-title>
          <v-card-text>
            <FileUpload
              ownerType="Patient::Avatar"
              :ownerId="attendance.patient.avatar.id"
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="light-blue" dark small @click="exibe" v-if="false">
              Utilizar câmera
              <v-icon>ri-camera-fill</v-icon>
            </v-btn>
          </v-card-actions>
          <v-card>
            <v-divider class="mx-4"></v-divider>
            <v-card-title>Documentos</v-card-title>
            <v-card-text>
              <FileUpload
                ownerType="Patient"
                :ownerId="attendance.patient.id"
              />
            </v-card-text>
          </v-card>
        </v-card>

        <v-card v-else-if="value == paths.patientInformation">
          <PatientInformation :attendance="attendance" />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-dialog>
</template>

<script>
import PatientPicture from "@/components/queues/attendance/patient_picture.vue";
import PatientInformation from "./patient_information.vue";


export default {
  name: "PatientAvatar",
  components: {
    PatientPicture,
    PatientInformation,
  },
  props: {
    attendance: Object,
  },
  data() {
    return {
      headers: [{ text: "Data de Nascimento", value: "birthDate" }],
      tabs: null,
      archives: [],
      showDialog: false,
      avatarPicture: null,
      currentFile: null,
      paths: {
        documents: "Anexos",
        patientInformation: "Folha de Rosto",
      },
    };
  },
  computed: {
    pictureUrl() {
      return this.attendance.patient.pictureUrl;
    },
    atual() {
      return this.lodash.first(this.pondFiles);
    },
    borderClass() {
      return this.attendance.fittedSchedule ? "border-fitted" : "border-normal";
    },
  },
};
</script>

<style lang="scss" scoped>
.border- {
  &normal {
    border: none;
  }
  &fitted {
    border: solid 4px var(--v-pink-lighten1);
  }
}

.inner-border {
  border: 7px solid transparent;
}
</style>